import Pristine from 'pristinejs';
import axios from 'axios';
import MultiDropdown from './multi_dropdown';
import Dropdown from './dropdown';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
// import Dropzone from 'dropzone';

export default {
    selected_view: null,
    error_message: "",
    init() {
        // let stage_0_button = document.getElementById('stage-0-button');
        let stage_1_button = document.getElementById('stage-1-button');
        let stage_2_button = document.getElementById('stage-2-button');
        let stage_3_button = document.getElementById('stage-3-button');
        let stage_4_button = document.getElementById('stage-4-button');
        let password_button = document.getElementById('password-button');

        // let stage_0 = document.getElementById('stage-0');
        let stage_1 = document.getElementById('stage-1');
        let stage_2 = document.getElementById('stage-2');
        let stage_3 = document.getElementById('stage-3');
        let stage_4 = document.getElementById('stage-4');
        let password_stage = document.getElementById('password-stage')

        //back buttons
        let back_2 = document.getElementById('stage-2__back');
        let back_3 = document.getElementById('stage-3__back');
        let password_back = document.getElementById('password-back');

        let header_1 = document.getElementsByClassName('register-header-button-1');
        let header_2 = document.getElementsByClassName('register-header-button-2');
        let header_3 = document.getElementsByClassName('register-header-button-3');
        let header_4 = document.getElementsByClassName('register-header-button-3');
        let password_header = document.getElementsByClassName('register-header-button-2');

        let image_upload = document.getElementById('image-upload');

        let is_logged_in = false;

        if(stage_1) {
            this.selected_view = stage_1

            /** When linkedin field has been clicked for the first time add linkedin.com as default
             * so users can add a value.
             */
            let linkedin_field = document.getElementById('linkedin_username');
            let twitter_field = document.getElementById('twitter_handle')
            // let linkedin_clicked = false;

            linkedin_field.addEventListener('click', () => {
                if(linkedin_field.value === '') {
                    linkedin_field.value = "https://linkedin.com/";
                }
                
                // linkedin_clicked = true;
            });

            twitter_field.addEventListener('click', () => {
                if(twitter_field.value === '') {
                    twitter_field.value = "@";
                }
            })

            if(stage_1.previousElementSibling.classList.contains('register-header')) {
                stage_1.previousElementSibling.classList.add('stage-show')
                // this.showNext(stage_1, stage_2)
                // this.selected_view = stage_2;
            }
        }

        //header and footer to be hidden when past stage 0.
        let header = document.getElementById('header');
        let footer = document.getElementById('footer');

        // console.log("Hey from get_connected, button 0 is " + stage_0);

        var that = this;

        // if(stage_0_button) {
        //     stage_0_button.addEventListener('click', function(e) { 
        //         that.showNext(stage_0, stage_1) 
        //         header.style.display = 'none';
        //         footer.style.display = 'none';
        //     })
        // }
        let register_form = document.getElementById('register-form');

        if(register_form) {
            //selected work and contact areas
            let work_areas = [];
            let contact_areas = [];
            let las_values = [];

            if(register_form.dataset.logged_in) {
                is_logged_in = true;
                header_2 = document.getElementsByClassName('register-header-button-3')
                header_3 = document.getElementsByClassName('register-header-button-4')


                let dropdown = document.getElementById('la');

                if(dropdown) {
                    let container = dropdown.parentElement;
                    let la_value = document.getElementById('la_value').value
                    if(la_value) {
                        Dropdown.drawOptions(container, undefined, true, document.getElementById('la_value').value);
                    }
                }
            }

            // grecaptcha.ready(function () {
            //     grecaptcha.execute('6LcA5-cUAAAAAIjKNUBgO_5OEkjGcXzKrlE0Bzg1', { action: 'contact' }).then(function (token) {
            //         var recaptchaResponse = document.getElementById('recaptchaResponse');
            //         recaptchaResponse.value = token;
            //     });
            // });

            var pristine = new Pristine(register_form, {
                classTo: 'registration-input',
                errorClass: 'invalid',
                successClass: 'valid',
                errorTextParent: 'registration-input',
                errorTextTag: 'p',
                errorTextClass: 'registration-input__validation'
            }, false);

            let website = window.location.origin + '/wp-json/integrated/is_user';
            let is_email_website = window.location.origin + '/wp-json/integrated/is_email';
            let linkedin_website = window.location.origin + '/wp-json/integrated/linkedin';
            let email_address_field = document.getElementById("email_address")
            let school_or_institute_field = document.getElementById('school_or_institution');
            let job_title_field = document.getElementById('job_title');
            let first_name_field = document.getElementById('first_name');
            let last_name_field = document.getElementById('surname');
            let linkedin_field = document.getElementById('linkedin_username');
            let la_field = document.getElementById('la');
            let twitter_field = document.getElementById('twitter_handle');
            //hidden text field for the dropdown
            let la_text = document.getElementById('la_text');
            let hide_email = document.getElementById('hide_email');

            if(is_logged_in) {
                var curr_password = document.getElementById('curr_password');
                var new_password = document.getElementById('new_password');
                var confirm_new_password = document.getElementById('confirm_new_password');
            } else {
                // var password_field = document.getElementById('password');
            }

            // pristine.addValidator(email_address_field, function(value, el) {

            //     if (value.length && value[0] === value[0].toUpperCase()){
            //        return true;
            //     }
            //     return false;
            // }, "The first character must be capitalized", 2, false);

            let that = this;
            pristine.addValidator(linkedin_field, function(value) {
                let is_linkedin_valid = false;
                jQuery.ajax({
                    url: linkedin_website,
                    type: "POST",
                    // url: is_linkedin_valid,
                    data: {
                        linkedin_username: value
                    },
                    success: function(result) {
                        console.log("linkedin: " + result.message)
                        if(result.status === true) {
                            is_linkedin_valid = true;
                            return true;
                        }

                        is_linkedin_valid = false;
                        return false;
                    },
                    error: function(result) {
                        is_linkedin_valid = false;
                        return false;
                    },
                    async: false
                })

                return is_linkedin_valid
            }, "Linkedin profile link is invalid");

            pristine.addValidator(email_address_field, function(value) {
                let is_email = false;
                jQuery.ajax({
                    type: "POST",
                    url: is_email_website,
                    data: {
                        email_address: value
                    },
                    success: function(result) {
                        if(result.status === true) {
                            is_email = true;
                            return true;
                        } 

                        is_email = false;
                        return false;
                    },
                    error: function(result) {
                        return false;
                    },
                    async: false
                })
                return is_email
            }, "Please enter a valid email address");

            pristine.addValidator(email_address_field, function(value, el) { 
                console.log("Code not ran.")
                let email_does_not_exist = false;
                jQuery.ajax({
                    type: 'POST',
                    url: website,
                    data: {
                        email_address: value,
                        logged_in: is_logged_in,
                        user_id: (is_logged_in === true) ? document.getElementById('user_id').value : -1
                    },
                    success: function(result) {
                        console.log("Email is valid: ", result);
                        if(result.status === true) {
                            email_does_not_exist = true;
                            return true;
                        } 

                        email_does_not_exist = false;
                        return false;
                    },
                    error: function(result) {
                        return false;
                    },
                    async: false
                })
                return email_does_not_exist;
            }, "Email address already taken");

            if(is_logged_in === true) {
                pristine.addValidator(curr_password, function(value, el) {
                    if((new_password.value !== '' || confirm_new_password.value !== '') && curr_password.value === '') {
                        return false;
                    }

                    return true;
                }, 'Please enter your current password')

                pristine.addValidator(new_password, function(value, el) {
                    if(new_password.value !== confirm_new_password.value) {
                        return false;
                    }

                    return true;
                }, "Passwords do not match", 1);

                let password_website = window.location.origin + '/wp-json/integrated/password_correct';
                pristine.addValidator(curr_password, function(value) {
                    let is_password_valid = false;

                    if(curr_password.value === '') {
                        return true;
                    }

                    jQuery.ajax({
                        type: 'POST',
                        url: password_website,
                        data: {
                            user_id: document.getElementById('user_id').value,
                            password: curr_password.value
                        },
                        success: function(result) {
                            console.log("Password", result)
                            if(result.status === true) {
                                is_password_valid = true;
                                return true;
                            } 

                            is_password_valid = false;
                            return false;
                        },
                        error: function(result) {
                            is_password_valid = false;
                            return false;
                        },
                        async: false
                    })

                    return is_password_valid
                }, 'Password incorrect')
            }

            let hidden_error = "In order to create an account please share at least one contact method";
            
            pristine.addValidator(twitter_field, (value) =>  {
                return that.hidden_validate(value, linkedin_field.value, hide_email);
            }, hidden_error)

            pristine.addValidator(linkedin_field, (value) => {
                return that.hidden_validate(twitter_field.value, value, hide_email);
            }, hidden_error)

            let save_buttons = document.getElementsByClassName('save-profile');
            //when a save button is clicked, update the profile after validation.
            if(save_buttons) {
                for(let i = 0; i < save_buttons.length; i++) {
                    let save_button = save_buttons[i];
                    save_button.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.deactivate_button(save_button);
                        setTimeout(() => {
                            var valid =  pristine.validate();
                            let contains_errors = false;

                            let errors = [
                                pristine.getErrors(email_address_field),
                                pristine.getErrors(first_name_field),
                                pristine.getErrors(last_name_field),
                                pristine.getErrors(school_or_institute_field),
                                pristine.getErrors(job_title_field),
                                pristine.getErrors(linkedin_field),
                                // pristine.getErrors(la_text)    
                            ]
        
                            if(curr_password.value !== '' || new_password.value !== '' || confirm_new_password !== '') {
                                errors.push(
                                    pristine.getErrors(curr_password),
                                    pristine.getErrors(new_password),
                                    pristine.getErrors(confirm_new_password),
                                );
                            }
        
                            let contact_areas = MultiDropdown.get_values("contact-areas");
                            let work_areas = MultiDropdown.get_values("the-work-areas");
                            let las_values = MultiDropdown.get_values("las");
        
                            if(work_areas.length === 0) {
                                // pristine.addError(document.getElementById('work-areas'), "Please select at least 1 work area");
                                var work_area_dropdown = document.getElementById('work-areas');
                                work_area_dropdown.innerHTML = "";
                                $(work_area_dropdown).append('<p class = "registration-input__validation">Please select at least 1 work area</p>')
                                contains_errors = true;
                            } else {
                                document.getElementById('work-areas').innerHTML = "";
                            }
                            
        
                            if(contact_areas.length === 0) {
                                // pristine.addError(document.getElementById('contact-areas'), 'Please select at least 1 area to be contacted about');
                                var contact_area_dropdown = document.getElementById('contact-areas');
                                contact_area_dropdown.innerHTML = "";
                                $(contact_area_dropdown).append('<p class = "registration-input__validation">Please select at least 1 area to be contacted about</p>')
                                contains_errors = true;
                            } else {
                                document.getElementById('contact-areas').innerHTML = "";
                            }
                            
                            if(las_values.length === 0) {
                                var las_dropdown = document.getElementById('las-areas');
                                las_dropdown.innerHTML = "";
                                $(las_dropdown).append('<p class = "registration-input__validation">Please select at least 1 LA</p>');
                                contains_errors = true;
                            } else {
                                document.getElementById('las-areas').innerHTML = "";
                            }
        
                            if(!that.has_errors(errors) && contact_areas.length !== 0 && work_areas.length !== 0 && las_values.length !== 0) {
                                this.save_profile(save_button, work_areas, contact_areas, las_values);
                                curr_password.value = "";
                                curr_password.innerHTML = "";

                                new_password.value = "";
                                new_password.innerHTML = "";

                                confirm_new_password.value = "";
                                confirm_new_password.innerHTML = "";
                            } else {
                                this.activate_button(save_button, true);
                            }
                        });
                    });
                }
            }

            let stage_2_checkboxes = document.getElementById('stage-2-checkboxes');

            // if(stage_2_checkboxes) {
            //     // stage_2_checkboxes.pristine = pristine;
            //     // stage_2_checkboxes.pristine.validators = {};

            //     let checkboxes = 

            //     pristine.addValidator(stage_2_checkboxes, function(value, el) {
            //         let checkboxes = document.getElementsByTagName('input');
            //         for(let i = 0; i < checkboxes.length; i++) {
            //             console.log("Checkbox has value " + checkboxes[i].value);
            //             if(checkboxes[i].value === true) {
            //                 return true;
            //             }
            //         }

            //         return false;
            //     }, "Must select at least 1 interest", 2, false);
            // }
            
            if(stage_1_button) {
                stage_1_button.addEventListener('click', async function(e) { 
                    e.preventDefault();
                    that.deactivate_button(stage_1_button);
                    setTimeout(() => {
                        // let validated = pristine.validate();
                        // console.log("validated " + validated);
                        let website = window.location.origin + '/wp-json/integrated/is_user';
                        let is_not_email = false;
                        let contains_errors = false;

                        var valid =  pristine.validate();

                        let errors;


                        if(is_logged_in === false) {
                            errors = [
                                pristine.getErrors(email_address_field),
                                pristine.getErrors(first_name_field),
                                pristine.getErrors(last_name_field),
                                // pristine.getErrors(password_field),
                                pristine.getErrors(school_or_institute_field),
                                pristine.getErrors(job_title_field),
                                pristine.getErrors(linkedin_field),
                            ];
                        } else {
                            errors = [
                                pristine.getErrors(email_address_field),
                                pristine.getErrors(first_name_field),
                                pristine.getErrors(last_name_field),
                                pristine.getErrors(school_or_institute_field),
                                pristine.getErrors(job_title_field),
                                pristine.getErrors(linkedin_field),
                            ]
                        }

                        las_values = MultiDropdown.get_values("las");
        
                        if(las_values.length === 0) {
                            var las_dropdown = document.getElementById('las-areas');
                            las_dropdown.innerHTML = "";
                            $(las_dropdown).append('<p class = "registration-input__validation">Please select at least 1 LA</p>');
                            contains_errors = true;
                        } else {
                            document.getElementById('las-areas').innerHTML = "";
                        }
                            

                        // let email_address_errors = pristine.getErrors(email_address_field);
                        // let 

                        // if(validated) {
                        if(!that.has_errors(errors) && las_values.length !== 0) {
                            if(is_logged_in === false) {
                                that.showNext(stage_1, stage_2)
                                that.selected_view = stage_2;
                            } else {
                                that.showNext(stage_1, password_stage);
                                that.selected_view = password_stage;
                            }

                            pristine.reset();
                        }

                        that.activate_button(stage_1_button)
                    }, 100)  
                    // }
                })
            }

            if(password_button) {
                if(is_logged_in === true) {
                    password_button.addEventListener('click', (e) => {
                        e.preventDefault();

                        that.deactivate_button(password_button)

                        var valid =  pristine.validate();

                        let errors = [
                            pristine.getErrors(curr_password),
                            pristine.getErrors(new_password),
                            pristine.getErrors(confirm_new_password),
                        ]

                        if(!that.has_errors(errors)) {
                            that.showNext(password_stage, stage_2);
                            that.selected_view = stage_2;
                        }

                        that.activate_button(password_button)
                    })

                }
            }

            if(stage_2_button) {

                // MultiDropdown.init();

                let inputs = document.querySelectorAll('input[name="contact-areas"]');
                for(let i = 0; i < inputs.length; i++) {
                    let option = inputs[i].parentElement.parentElement;
                    option.addEventListener('click', (e) => {
                        contact_areas = MultiDropdown.get_values("contact-areas");
                    })
                }
    
                let work_inputs = document.querySelectorAll('input[name="the-work-areas"]');
                for(let i = 0; i < work_inputs.length; i++) {
                    let option = work_inputs[i].parentElement.parentElement;
                    option.addEventListener('click', (e) => {
                        work_areas = MultiDropdown.get_values("the-work-areas");
                    })
                }

                stage_2_button.addEventListener('click', function(e) { 
                    e.preventDefault();
                    that.deactivate_button(stage_2_button)

                    let contains_errors = false;

                    contact_areas = MultiDropdown.get_values("contact-areas");
                    work_areas = MultiDropdown.get_values("the-work-areas");


                    if(work_areas.length === 0) {
                        // pristine.addError(document.getElementById('work-areas'), "Please select at least 1 work area");
                        var work_area_dropdown = document.getElementById('work-areas');
                        work_area_dropdown.innerHTML = "";
                        $(work_area_dropdown).append('<p class = "registration-input__validation">Please select at least 1 work area</p>')
                        contains_errors = true;
                    } else {
                        document.getElementById('work-areas').innerHTML = "";
                    }

                    if(contact_areas.length === 0) {
                        // pristine.addError(document.getElementById('contact-areas'), 'Please select at least 1 area to be contacted about');
                        var contact_area_dropdown = document.getElementById('contact-areas');
                        contact_area_dropdown.innerHTML = "";
                        $(contact_area_dropdown).append('<p class = "registration-input__validation">Please select at least 1 area to be contacted about</p>')
                        contains_errors = true;
                    } else {
                        document.getElementById('contact-areas').innerHTML = "";
                    }

                    
                    setTimeout(() => {
                        // let validated = pristine.validate();

                        let validate = pristine.validate();
                        
                        // let errors = [];
                        // let interest_elements = document.querySelectorAll('input[name="interests"]:checked');
                        // for(let i = 0; i < interest_elements.length; i++) {
                        //     errors.push(pristine.getErrors(interest_elements[i]));
                        // }
                        
                        if(!that.search_for_error(pristine.getErrors(), "Please select at least 1 interest") && contains_errors === false) {
                            that.showNext(stage_2, stage_3);
                            that.selected_view = stage_3;
                            pristine.reset();
                        }

                        that.activate_button(stage_2_button)
                    }, 100);
                })
            }

            if(stage_3_button) {
                stage_3_button.addEventListener('click', function(e) { 
                    e.preventDefault();
                    that.deactivate_button(stage_3_button);

                    setTimeout(() => {
                        let validated = pristine.validate();

                        if(validated) {
                            // var recaptcha_response = document.getElementById('recaptchaResponse').value;
                            let website = window.location.origin + '/wp-json/integrated/account';
                            if(is_logged_in === false) {

                                var form_data = new FormData();
                                form_data.append('first_name', document.getElementById('first_name').value);
                                form_data.append('surname', document.getElementById('surname').value);
                                form_data.append('job_title', document.getElementById('job_title').value);
                                form_data.append('school_or_institute', document.getElementById('school_or_institution').value);
                                form_data.append('email_address', document.getElementById('email_address').value);
                                // form_data.append('password', document.getElementById('password').value);
                                form_data.append('twitter_handle', document.getElementById('twitter_handle').value);
                                form_data.append('linkedin_username', document.getElementById('linkedin_username').value);
                                form_data.append('user_info', document.getElementById('user_info').value);
                                // form_data.append('local_authority', document.getElementById('la').value);
                                form_data.append('hide_email', (document.getElementById('hide_email').checked) ? 'true' : 'false');
                                form_data.append('to_be_contacted', (document.getElementById('journalists').checked) ? 'true' : 'false');
                                // let la_dropdown_value = document.getElementById('la').value;
                                // let la_hidden_value = document.getElementById('la_value').value;
                                // let default_dropdown_text = "Local Authority..."
                                
                                // if(la_dropdown_value !== default_dropdown_text) {
                                //     form_data.append('local_authority', la_dropdown_value);                                        
                                // }

                                form_data.append('subscribed', document.getElementById('subscribed').checked);

                                for (var i = 0; i < work_areas.length; i++) {
                                    form_data.append('work_areas[]', work_areas[i]);
                                }

                                for (var i = 0; i < contact_areas.length; i++) {
                                    form_data.append('contact_areas[]', contact_areas[i]);
                                }

                                for(let i = 0; i < las_values.length; i++) {
                                    form_data.append('las[]', las_values[i]);
                                }
                                
                                // form_data.append('contact_areas', contact_areas);
                                // form_data.append('work_areas', work_areas);
                                form_data.append('image', $('#sortpicture').prop('files')[0]);
                                // form_data.append('recaptcha_response', recaptcha_response);

                                axios.post(website, form_data)
                                .then(function (result) {
                                    console.log(result);
                                    if(result.data.success == true) {
                                        console.log(result.data.message);
                                        that.showNext(stage_3, stage_4);
                                        that.selected_view = stage_4;
                                    } else {
                                        if(result.code) {
                                            console.log("Code: " + result.code);
                                        }

                                        console.log("Message: " + result.message)

                                        if(result.data) {
                                            console.log("Data: " + result.data);
                                        }
                                    }
                                    that.activate_button(stage_3_button);
                                })
                                .catch(function (result) {
                                    console.log("Failed to register user: ", result);
                                    that.activate_button(stage_3_button);
                                })
                            } else {
                                save_profile();
                            }
                        }
                        // that.activate_button(stage_3_button);
                    }, 100);
                })
            }


            //when the mobile dropdown is selected to change the forms.
            let mobile_header_dropdowns = document.querySelectorAll('.mobile-header-dropdown select');
            if(mobile_header_dropdowns) {
                function reset_header_dropdowns(val) {
                    let mobile_header_dropdowns = document.querySelectorAll('.mobile-header-dropdown select');
                    for(let i = 0; i < mobile_header_dropdowns.length; i++) {
                        Dropdown.reset_this(mobile_header_dropdowns[i], val);
                    }
                }
                for(let i = 0; i < mobile_header_dropdowns.length; i++) {
                    $(mobile_header_dropdowns[i]).change((e) => {
                        let selected_page = e.target.value;

                        switch(selected_page.toLowerCase()) {
                            case "update personal info...":
                                this.showNext(this.selected_view, stage_1);
                                this.selected_view = stage_1;
                                reset_header_dropdowns(selected_page);
                                break;
                            case "update password...":
                                this.showNext(this.selected_view, password_stage);
                                this.selected_view = password_stage;
                                reset_header_dropdowns(selected_page);
                                break;
                            case "update sectors...":
                                this.showNext(this.selected_view, stage_2);
                                this.selected_view = stage_2;
                                reset_header_dropdowns(selected_page);
                                break;
                            case "update about you...":
                                this.showNext(this.selected_view, stage_3);
                                this.selected_view = stage_3;
                                reset_header_dropdowns(selected_page);
                                break;
                        }
                    });
                }
            }    

            if(header_1) {
                for(let i = 0; i < header_1.length; i++) {
                    header_1[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        if(!e.target.disabled) {
                            this.showNext(this.selected_view, stage_1);
                            this.selected_view = stage_1;
                            console.log("Going back to stage 1")
                        }
                    })
                }
            }

            if(password_header) {
                for(let i = 0; i < password_header.length; i++) {
                    password_header[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        if(!e.target.disabled) {
                            this.showNext(this.selected_view, password_stage);
                            this.selected_view = password_stage;
                        }
                    })
                }
            }

            if(password_back) {
                password_back.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.showNext(this.selected_view, stage_1);
                    this.selected_view = stage_1;
                })
            }

            //when the back buttons are clicked go back to a previous page.
            if(back_2) {
                back_2.addEventListener('click', (e) => {
                    e.preventDefault();
                    if(is_logged_in === false) {
                        this.showNext(this.selected_view, stage_1);
                        this.selected_view = stage_1
                    } else {
                        this.showNext(this.selected_view, password_stage);
                        this.selected_view = password_stage;
                    }
                });
            }

            if(back_3) {
                back_3.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.showNext(this.selected_view, stage_2);
                    this.selected_view = stage_2;
                })
            }

            if(header_2) {
                for(let i = 0; i < header_2.length; i++) {
                    header_2[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        if(!e.target.disabled) {
                            this.showNext(this.selected_view, stage_2);
                            this.selected_view = stage_2;
                            console.log("Going back to stage 2")
                        }
                    })
                }
            }

            if(header_3) {
                for(let i = 0; i < header_3.length; i++) {
                    header_3[i].addEventListener('click', (e) => {
                        e.preventDefault();
                        if(!e.target.disabled) {
                            this.showNext(this.selected_view, stage_3);
                            this.selected_view = stage_3;
                            console.log("Going back to stage 3")
                        }
                    })
                }
            }
        }
    },
    showNext(this_stage, next_stage) {
        console.log("Showing next stage");

        this_stage.classList.add('stage-hide');
        this_stage.classList.remove('stage-show');
        next_stage.classList.add('stage-show');

        if(this_stage.previousElementSibling.classList.contains('register-header')) {
            this_stage.previousElementSibling.classList.remove('stage-show');
        }

        if(next_stage.previousElementSibling.classList.contains('register-header')) {
            next_stage.previousElementSibling.classList.add('stage-show')
        }

        if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > -1){
        /* Microsoft Internet Explorer detected in. */
            window.scrollTo(0, 0);
        } else {
            //next_stage.scrollIntoView({behavior: "smooth"});
            // Changed at clients request
            window.scrollTo(0, 0);
        }
    },
    check_validation(stage) {
        let children = stage.getElementsByTagName("*");
        if(children.length > 0) {
            for(let i = 0; i < children.length; i++) {
            let child = children[i];
                if(child.classList.contains('invalid')) {
                    return false;
                }
            }
        }

        return true;
    },
    //Get erros for given inputs.
    has_errors(error_array) {
        let errors_present = false;
        for(let i = 0; i < error_array.length; i++) {
            let error_array_element = error_array[i];
            if(error_array_element.length > 0) {
                errors_present = true;
                break;
            }
        }

        return errors_present;
    },
    search_for_error(errors, to_search) {
        let found_error = false;
        for(let i = 0; i < errors.length; i++) {
            if(errors[i].errors) {
                if (errors[i].errors.find((element) => element === to_search)) {
                    found_error = true;
                    break;
                }
            }
        }
        return found_error;

    },
    deactivate_button(button) {
        button.disabled = true;
        button.getElementsByTagName('span')[0].innerHTML = "Submitting"
        // button.style.backgroundColor = 'red';
        // button.style.display = "none";
    },
    activate_button(button, save = false) {
        button.disabled = false;
        if(!save) {
            button.getElementsByTagName('span')[0].innerHTML = "Continue"
        } else {
            button.getElementsByTagName('span')[0].innerHTML = "Save"
        }
        // button.style.backgroundColor = 'orange';
    },
    hidden_validate(twitter_value, linkedin_value, checkbox) {
        if(twitter_value === "" && linkedin_value == "" && checkbox.checked === false) {
            return false;
        }

        return true;
    },
    save_profile(button, work_areas, contact_areas, las) {
        let update_website = window.location.origin + '/wp-json/integrated/update_account'
        var form_data = new FormData();
        form_data.append('user_id', document.getElementById('user_id').value);
        form_data.append('first_name', document.getElementById('first_name').value);
        form_data.append('surname', document.getElementById('surname').value);
        form_data.append('job_title', document.getElementById('job_title').value);
        form_data.append('school_or_institute', document.getElementById('school_or_institution').value);
        form_data.append('email_address', document.getElementById('email_address').value);
        form_data.append('old_password', document.getElementById('curr_password').value);
        form_data.append('new_password', document.getElementById('new_password').value);
        form_data.append('twitter_handle', document.getElementById('twitter_handle').value);
        form_data.append('linkedin_username', document.getElementById('linkedin_username').value);
        form_data.append('user_info', document.getElementById('user_info').value);
        // form_data.append('la', document.getElementById('la').value);
        form_data.append('hide_email', (document.getElementById('hide_email').checked) ? 'true' : 'false');
        form_data.append('to_be_contacted', (document.getElementById('journalists').checked) ? 'true' : 'false');
        // let la_dropdown_value = document.getElementById('la').value;
        // let la_hidden_value = document.getElementById('la_value').value;
        // let default_dropdown_text = "Local Authority..."

        // if(la_dropdown_value !== default_dropdown_text) {
        //     form_data.append('local_authority', la_dropdown_value);                                        
        // } else if(la_hidden_value) {
        //     form_data.append('local_authority', la_hidden_value);
        // }

        for (var i = 0; i < work_areas.length; i++) {
            form_data.append('work_areas[]', work_areas[i]);
        }

        for (var i = 0; i < contact_areas.length; i++) {
            form_data.append('contact_areas[]', contact_areas[i]);
        }

        for (var i = 0; i < las.length; i++) {
            form_data.append('las[]', las[i]);
        }

        // form_data.append('contact_areas', contact_areas);
        // form_data.append('work_areas', work_areas);
        form_data.append('image', $('#sortpicture').prop('files')[0]);
        let that = this;
        // form_data.append('recaptcha_response', recaptcha_response);
        jQuery.ajax({
            type: 'POST',
            url: update_website,
            data: form_data,
            processData: false,
            contentType: false,
            success: function (result) {
                if(!result.code && result.success == true) {
                    console.log(result.message);
                    // that.showNext(stage_3, stage_4);
                    // that.selected_view = stage_4;
                    that.activate_button(button, true);

                    //opening modal when the account has been updated successfully.
                    let update_modal = document.getElementById('success-update-modal');
                    if(update_modal) {
                        update_modal.classList.add('active');
                        disablePageScroll();

                        let exit = update_modal.querySelector('.modal-close');
                        exit.addEventListener('click', (e) => {
                            update_modal.classList.remove('active');
                            enablePageScroll();
                        })
            
                        update_modal.addEventListener('click', (e) => {
                            e.stopPropagation();
                            if(e.target === update_modal) {
                                update_modal.classList.remove('active');
                                enablePageScroll();
                            }
                        });
                    }
                } else {
                    if(result.code) {
                        console.log("Code: " + result.code);
                    }

                    console.log("Message: " + result.message)

                    if(result.data) {
                        console.log("Data: " + result.data);
                    }
                    that.activate_button(button, true);
                }
                
                // that.set_posts(JSON.parse(result))
            },
            error: function(result) {
                console.log("Failed to register user: ", result);
                that.activate_button(button, true);
            },
            async: false
        });
        
    }
}